module.exports = __webpack_public_path__ + "img/logo.cba31781.svg";